import { OloSetTableNumberAs } from './olo_set_table_number_as.js';

export function name(setTableNumberAs: OloSetTableNumberAs): string {
  switch (setTableNumberAs) {
    case OloSetTableNumberAs.TableNumber:
      return 'Table Number';
    case OloSetTableNumberAs.OrderNumber:
      return 'Order Number';
  }
}
